module.exports = __webpack_public_path__ + "img/BlendBuff-MDef.cf357034.png";